// Only used on the web
export function contextIdToId(contextId: number) {
  return "rnwgpu-canvas-" + contextId;
}
